function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "bfaee591-1150-4c02-8d99-180d701f6f61",
  x1: 777.82,
  y1: 813.84,
  x2: 777.82,
  y2: 182.84,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "451b59ba-420b-4fc9-a211-ed64f18bebb9",
  x1: 475.85,
  y1: 808.79,
  x2: 475.85,
  y2: 120.27,
  gradientTransform: "matrix(-1, 0, 0, 1, 1038, 0)",
  xlinkHref: "#bfaee591-1150-4c02-8d99-180d701f6f61"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "makeup artist");

var _ref4 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 493.65,
  cy: 752.61,
  rx: 307.5,
  ry: 49.5,
  opacity: 0.1
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M595.3,686.11c64.23-35.55,137.6-46.9,209.3-31.65,101.61,21.6,229.3,13.13,254-153.51,42.24-284.61-134.78-359.73-134.78-359.73s-117.72-9.86-187.33-47.4c-98.88-53.32-211.9-60.13-311.28-15-63.55,28.83-115.88,69-124.83,124.11-25,154.18,16.06,239.12-60.75,289.45s-11.17,188.51,47.74,183.73,191.95-57.26,243.8,3.52C549.6,701.16,572.9,698.51,595.3,686.11Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref6 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 853.87,
  cy: 718.89,
  rx: 45,
  ry: 16,
  opacity: 0.1
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M986.9,770.11s12-40.84-2.26-70.9a64.51,64.51,0,0,1-5.22-40.47,108.49,108.49,0,0,1,5.73-19",
  transform: "translate(-134.85 -48.95)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M976.27,620.75c0,5,9.06,19.52,9.06,19.52s9.06-14.51,9.06-19.52a9.06,9.06,0,1,0-18.13,0Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M961.29,648.48c2.72,4.2,18.22,11.46,18.22,11.46s-.28-17.11-3-21.31a9.06,9.06,0,1,0-15.21,9.85Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M961.94,695.85c4.47,2.25,21.51.7,21.51.7s-8.88-14.63-13.35-16.88a9.06,9.06,0,1,0-8.16,16.18Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M970.51,731.59c4,3,21.08,4.32,21.08,4.32S985.31,720,981.29,717a9.06,9.06,0,1,0-10.78,14.57Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M998.53,660.91c-3.59,3.49-20.32,7.1-20.32,7.1s4.1-16.61,7.69-20.1a9.06,9.06,0,1,1,12.63,13Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1008,702.82c-4.47,2.25-21.51.7-21.51.7s8.88-14.63,13.35-16.88a9.06,9.06,0,1,1,8.16,16.18Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1011.66,744.83c-4,3-21.08,4.32-21.08,4.32s6.28-15.92,10.3-18.89a9.06,9.06,0,0,1,10.78,14.57Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 63.87,
  cy: 698.89,
  rx: 45,
  ry: 16,
  opacity: 0.1
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.76,748s25.67-87.17-4.81-151.32c-12.8-26.93-17-57.15-11.13-86.37A231.54,231.54,0,0,1,195,469.73",
  transform: "translate(-134.85 -48.95)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176.07,429.18c0,10.68,19.34,41.66,19.34,41.66s19.34-31,19.34-41.66a19.34,19.34,0,0,0-38.68,0Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.1,488.35c5.81,9,38.88,24.46,38.88,24.46s-.6-36.52-6.41-45.48a19.34,19.34,0,1,0-32.47,21Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M145.49,589.47C155,594.28,191.4,591,191.4,591s-19-31.22-28.49-36a19.34,19.34,0,1,0-17.42,34.54Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.78,665.74c8.59,6.35,45,9.22,45,9.22s-13.4-34-22-40.32a19.34,19.34,0,1,0-23,31.1Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M223.59,514.88c-7.66,7.44-43.36,15.15-43.36,15.15s8.74-35.46,16.4-42.9a19.34,19.34,0,1,1,27,27.75Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.84,604.35c-9.54,4.81-45.91,1.49-45.91,1.49s19-31.22,28.49-36a19.34,19.34,0,1,1,17.42,34.54Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M251.59,694c-8.59,6.35-45,9.22-45,9.22s13.4-34,22-40.32a19.34,19.34,0,1,1,23,31.1Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M943.15,419.56a14,14,0,0,0,5.9-5.38,65.11,65.11,0,0,1-9.92-4L942,397.68a9,9,0,0,0-7-10.76l-3.4-.75a9.23,9.23,0,0,0-11,6.8l-.63,2.74a63.82,63.82,0,0,1-11.36-17.1,13,13,0,0,1-1.51-6.13c.19-2.55,1.7-4.79,2.93-7a37.3,37.3,0,0,0,3.88-25.15c-1.55-7.68-5.48-14.67-8-22.09a63.51,63.51,0,0,1,1.6-45c3.47-8.18,8.8-16.65,6.56-25.23-2.49-9.57-13-14.43-22-19s-18.53-12.58-16.66-22.29c.59-3.06,2.32-6.06,1.62-9.09-.94-4-5.59-6-9.64-7.24-10.83-3.44-21.82-6.91-33.2-7.44-9.34-.43-19.1,1.37-26.88,6.23a33.21,33.21,0,0,0-6.4,4.57,57.22,57.22,0,0,1-5.67,5.15c-4.1,2.07-9,1.8-13.63,2.24a35,35,0,0,0-15.06,5,27.89,27.89,0,0,0-7.49,5.77c-5.25,5.8-7.56,14.3-5,21.61a17,17,0,0,0,2.13,4.07,41.45,41.45,0,0,0-6.06,21.61c0,21.68,16.67,39.55,38.18,42.1,1.26,4.83,2.48,9.89,3.43,14.58a8.07,8.07,0,0,1-.81.64c-1.77.85-3.79,1.39-5.64,2.12a22.45,22.45,0,0,0-3.91,2c-9.15,4.93-13.84,15.61-17.62,25.37,2.6-.47,5.18-1,7.74-1.63-.13.32-.23.63-.32.92-2.63,9-17.13,59.14-17.13,59.14l3.08-6.62a4.85,4.85,0,0,1-.45,2.76c-1.28,2.49,1.17.68,5.06-2.91,0,.21.05.33.2.34-9.14,14.92-37.92,61.51-52.24,80.41-17.79,2.39-30.75,4.44-30.75,4.44a18,18,0,0,0-8.09,2,22,22,0,0,0-11.94,19l-1,31.67s-7.62,38.09-7.47,59.78a48.93,48.93,0,0,0,.88,10.93,74.82,74.82,0,0,1,1.75,16.55,119.55,119.55,0,0,1-1.75,19.45c.05.05.14.1.2.15-.12.73-.2,1.13-.2,1.13,1.45,1.41,5.89,2.44,11.56,3.18-1.6,8.9-7.48,18-24.73,18.67-25.2.95-30.43,5.37-31.43,7.64h0a2,2,0,0,0-.18,1.36c1.32,16.71,38.86,14.78,50.06,15.43a21.32,21.32,0,0,0,4.92-.45c1-.18,2-.41,3.07-.68,2.69-.68,5.71-1.64,8.86-2.78,3.78-1.37,7.76-3,11.62-4.77,1.93-.88,3.82-1.79,5.65-2.71,1.22-.62,2.4-1.24,3.54-1.86,5.71-3.1,10.34-6.2,12.39-8.61a6.17,6.17,0,0,0,.52-.7c.05-.09.1-.18.15-.27s.18-.32.26-.49.1-.23.14-.35.11-.3.16-.45.08-.27.12-.41.06-.28.09-.42.06-.31.08-.47,0-.23,0-.35c.52-5.39-3.53-12.72-6.82-17.66V625.49s4.66-49.17,4.57-70.87a50,50,0,0,0-.62-10.12,16.37,16.37,0,0,1-.5-3.17,7.29,7.29,0,0,1,5.77-7.11c11.72-6.1,42-3.61,64.64-.57-19.67,3-63.67,8.18-63.67,14.08v14a13.63,13.63,0,0,0,12.53,13.43V813.84h15.66V575.23H878.91V813.84h15.66V572.49a23.06,23.06,0,0,0,12.53-20.4v-3.47l29.15-126A26.19,26.19,0,0,0,943.15,419.56Zm-58.1,127.19c-.92-4-7.42-7.55-17.78-10.31,17.58-8.62,21.29-25.72,21.16-39A75.59,75.59,0,0,0,887.32,484a8.39,8.39,0,0,0,2.87-7.79,13.22,13.22,0,0,0-1.65-7.6c-10.4-21-12-33-12.22-49.32a24.62,24.62,0,0,0,7.05,4.61c6.14,2.65,13,3.12,19.73,3.06,3.25,0,6.5-.19,9.75-.44ZM777.85,421.08c.84,1.58,1.35,2.58,1.35,2.58l2.87-2.54c13.73.47,16.67,7.11,17.09,11.52a9.86,9.86,0,0,1-.2,1.3l-11.86,34.71c-20.59-3.17-29.59,2.35-32.13,4.41-6.35.6-12.81,1.3-19.17,2C748.57,458.44,766.17,436,777.85,421.08Z",
  transform: "translate(-134.85 -48.95)",
  fill: "url(#bfaee591-1150-4c02-8d99-180d701f6f61)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M744.64,377.46S698,456.09,687.07,466.53c0,0-46.64,48.4-22.93,45,1.74-.25,35.87-29.1,37.86-33.82s66.53-88.56,66.53-88.56l-9.2-8.47Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#f8bdc5"
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 873.32,
  y: 566.19,
  width: 14.79,
  height: 235.44,
  transform: "translate(1626.59 1318.88) rotate(-180)",
  fill: "#40414d"
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 725.44,
  y: 566.19,
  width: 14.79,
  height: 235.44,
  transform: "translate(1330.83 1318.88) rotate(-180)",
  fill: "#40414d"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M713.61,544c0,9,61.47,16.27,99.06,16.27S879.24,553,879.24,544s-29-16.27-66.58-16.27S713.61,535,713.61,544Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#f6c6cd"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M731.61,544H889.45A10.5,10.5,0,0,1,900,554.5v16.13a0,0,0,0,1,0,0H713.61a0,0,0,0,1,0,0V562A18,18,0,0,1,731.61,544Z",
  transform: "translate(1478.71 1065.68) rotate(-180)",
  fill: "#40414d"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M906.69,385.69h8.06a0,0,0,0,1,0,0V563.63a7,7,0,0,1-7,7H901a7,7,0,0,1-7-7V398.35a12.66,12.66,0,0,1,12.66-12.66Z",
  transform: "translate(1546.47 1094.76) rotate(-167.28)",
  fill: "#40414d"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M702,634.23s14.93,18.67,8.71,26.14-37.28,21.75-47.29,21.16c-10.58-.62-46,1.24-47.29-14.93,0,0-2.49-7.47,29.87-8.71S668.36,623,668.36,623Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#594c76"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M879.94,477.41s14.93,51-29.87,59.74l-48.54-2.49s-68.45-13.69-87.12-3.73c0,0-7.47,1.24-5,11.2s-3.73,77.16-3.73,77.16v22.4s-42.32,0-47.29-5c0,0,3.73-19.91,0-36.09s6.22-67.21,6.22-67.21l1-30.66a21.36,21.36,0,0,1,11.28-18.42,16.68,16.68,0,0,1,7.64-1.94s84.63-13.69,114.5-11.2S879.94,477.41,879.94,477.41Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M879.94,476.16s14.93,51-29.87,59.74l-48.54-2.49s-68.45-13.69-87.12-3.73c0,0-7.47,1.24-5,11.2S705.69,618,705.69,618v22.4s-42.32,0-47.29-5c0,0,3.73-19.91,0-36.09s6.22-67.21,6.22-67.21l1-30.66a21.36,21.36,0,0,1,11.28-18.42,16.68,16.68,0,0,1,7.64-1.94s84.63-13.69,114.5-11.2S879.94,476.16,879.94,476.16Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#8b9cd1"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M796.55,313.13s-22.4,26.14-24.89,34.85-29.87,31.11-29.87,31.11S761.7,394,758,401.49,784.1,376.6,784.1,376.6l34.85-51Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M796.55,313.13s-22.4,26.14-24.89,34.85-29.87,31.11-29.87,31.11S761.7,394,758,401.49,784.1,376.6,784.1,376.6l34.85-51Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M781.61,283.26s11.2,36.09,11.2,49.78,47.29-3.73,46-11.2-27.38-34.85-28.63-46S781.61,283.26,781.61,283.26Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#f8bdc5"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M819,308.15s43.56-11.2,49.78,52.27-5,70.94,13.69,109.52-126.95,5-126.95,5,7.47-8.71,31.11-5l11.2-33.6s3.73-14.93-17.42-14.93-11.2-43.56-11.2-43.56,11.2-37.34,17.42-41.07S804,310.64,819,308.15Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M819,305.66s43.56-11.2,49.78,52.27-5,70.94,13.69,109.52-126.95,5-126.95,5,7.47-8.71,31.11-5l11.2-33.6s3.73-14.93-17.42-14.93-11.2-43.56-11.2-43.56,11.2-37.34,17.42-41.07S804,308.15,819,305.66Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M765.64,394.46S719,473.09,708.07,483.53c0,0-46.64,48.4-22.93,45,1.74-.25,35.87-29.1,37.86-33.82s66.53-88.56,66.53-88.56l-9.2-8.47Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#f8bdc5"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M845.09,364.15l-66,59.74S766.68,399,762.95,399s44.8-73.43,44.8-73.43,12.45-14.93,19.91-7.47S857.53,320.59,845.09,364.15Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M846.33,361.66l-66,59.74s-12.45-24.89-16.18-24.89S809,323.08,809,323.08s12.45-14.93,19.91-7.47S858.78,318.1,846.33,361.66Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4527a0"
});

var _ref42 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 657.96,
  cy: 215.64,
  r: 41.07,
  fill: "#f8bdc5"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M772.84,251.09c-7.43,1-14.92-4.28-17.38-11.36s-.28-15.31,4.68-20.92,12.34-8.75,19.8-9.48c4.53-.44,9.36-.12,13.31-2.38,2.49-1.42,4.34-3.72,6.43-5.68,7.83-7.38,19.18-10.06,29.93-9.56s21.13,3.87,31.37,7.2c3.82,1.24,8.22,3.09,9.1,7,.67,2.94-1,5.85-1.53,8.8-1.76,9.39,7.29,17.11,15.74,21.58s18.41,9.17,20.76,18.44c2.11,8.31-2.92,16.5-6.2,24.42a62.9,62.9,0,0,0-1.51,43.54c2.4,7.18,6.12,14,7.58,21.39a36.9,36.9,0,0,1-3.66,24.35c-1.17,2.18-2.6,4.35-2.77,6.81a12.81,12.81,0,0,0,1.42,5.94,63.32,63.32,0,0,0,38.19,34.43c-2.67,4.84-8.5,6.86-13.88,8.13a127.81,127.81,0,0,1-28,3.38c-6.34.06-12.85-.39-18.64-3s-10.82-7.6-11.91-13.85c-.63-3.62.07-7.36-.38-11-1-8.2-7.59-14.63-10-22.53-2.31-7.55-3.65-8.7-2.76-16.55s.72-16.57-4.4-22.58c-5.36-6.3-14.78-7.7-22.86-5.91s-12.26-.74-19.64,3a151.84,151.84,0,0,1-40.94,13.92c3.86-10.22,8.71-21.49,18.83-25.62,2.9-1.18,6.26-1.81,8.23-4.24,3.14-3.88,1-10.1,3.71-14.28s9.16-4.37,12.87-7.85c3.15-3,3.73-7.91,2.51-12.05s-3.91-7.67-6.63-11q-3.61-4.49-7.39-8.84A33.26,33.26,0,0,1,791,256.5c-.85-2-.69-5.78-2.08-7.37C785.4,245.1,777.13,250.52,772.84,251.09Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M774.35,250.18c-7.43,1-14.92-4.28-17.38-11.36s-.28-15.31,4.68-20.92,12.34-8.75,19.8-9.48c4.53-.44,9.36-.12,13.31-2.38,2.49-1.42,4.34-3.72,6.43-5.68,7.83-7.38,19.18-10.06,29.93-9.56s21.13,3.87,31.37,7.2c3.82,1.24,8.22,3.09,9.1,7,.67,2.94-1,5.85-1.53,8.8-1.76,9.39,7.29,17.11,15.74,21.58s18.41,9.17,20.76,18.44c2.11,8.31-2.92,16.5-6.2,24.42a62.9,62.9,0,0,0-1.51,43.54c2.4,7.18,6.12,14,7.58,21.39a36.9,36.9,0,0,1-3.66,24.35c-1.17,2.18-2.6,4.35-2.77,6.81a12.81,12.81,0,0,0,1.42,5.94,63.32,63.32,0,0,0,38.19,34.43c-2.67,4.84-8.5,6.86-13.88,8.13a127.81,127.81,0,0,1-28,3.38c-6.34.06-12.85-.39-18.64-3s-10.82-7.6-11.91-13.85c-.63-3.62.07-7.36-.38-11-1-8.2-7.59-14.63-10-22.53-2.31-7.55-3.65-8.7-2.76-16.55s.72-16.57-4.4-22.58c-5.36-6.3-14.78-7.7-22.86-5.91s-12.26-.74-19.64,3a151.84,151.84,0,0,1-40.94,13.92c3.86-10.22,8.71-21.49,18.83-25.62,2.9-1.18,6.26-1.81,8.23-4.24,3.14-3.88,1-10.1,3.71-14.28s9.16-4.37,12.87-7.85c3.15-3,3.73-7.91,2.51-12.05s-3.91-7.67-6.63-11q-3.61-4.49-7.39-8.84a33.26,33.26,0,0,1-5.74-8.23c-.85-2-.69-5.78-2.08-7.37C786.91,244.19,778.64,249.62,774.35,250.18Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#eb6475"
});

var _ref45 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M669.78,632.83a43,43,0,0,0-1.42-9.8l.63.21A43.34,43.34,0,0,1,669.78,632.83Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fff"
}), React.createElement("path", {
  d: "M663.38,679c10,.59,41.07-13.69,47.29-21.16a6.64,6.64,0,0,0,1.44-3.53,7.81,7.81,0,0,1-1.44,6c-6.22,7.47-37.28,21.75-47.29,21.16-10.58-.62-46,1.24-47.29-14.93a2,2,0,0,1,.17-1.31C619.11,680.17,653.07,678.42,663.38,679Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fff"
}));

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M397.65,686.94c6-2,15-4.28,22.09-3.47,6.74-2.46,22.6-8.88,33.43-18.39a241,241,0,0,1,.71-28.24c5.54-63-6.92-104.49-6.92-104.49s-9.78-31.67-8.71-57.95c-.63,1.19-1,1.9-1,1.9-.86-22.67-8.58-46.13-14.36-60.74a4.88,4.88,0,0,1-.65-.24L415.67,400a13.31,13.31,0,0,1-1.22-2.83l-1-2.43.31-.13c-.1-.4-.21-.82-.31-1.25h0c-4.13-17.47-7.28-58.9-7.28-58.9-11.07-43.6,15.22-70.58,15.22-70.58L466,225.45a5.66,5.66,0,0,0-.44,1.57l.37-.32c.63-1.8,1.32-4,2-6.44a33.93,33.93,0,0,1-4.46-3.77,34.27,34.27,0,0,1-10-17.85c-1.08-5.31-.87-10.78-.65-16.19l.74-18.52a58.81,58.81,0,0,1,1.1-10.8c3.37-14.74,18.43-25,33.54-25.65,4.81-.2,9.61.41,14.4.77a96.85,96.85,0,0,0,11.7.25,2.12,2.12,0,0,0,1.26-.33,1.85,1.85,0,0,0,.55-1.28,6.37,6.37,0,0,0-1.56-4.77,5.94,5.94,0,0,0-2-1.16l1.08.26a5.88,5.88,0,0,0-1.77-.95c3.86.91,7.81,1.86,11.13,4a14.38,14.38,0,0,1,2.6,2.19,11.35,11.35,0,0,1,3.76,7c1.73-1.69,3.39-3.55,4-5.87a5.93,5.93,0,0,0,0-2.84q.39.49.76,1c0-.1,0-.2-.07-.3a29.7,29.7,0,0,1,5.81,12A4.66,4.66,0,0,0,540.8,134c.22.68.43,1.37.62,2.07a4.79,4.79,0,0,0,.07-1.38,47.32,47.32,0,0,1,2.31,16.43c0,5.56-2.46,14.21-8.42,16.16-.3.1-.62.18-.94.25a37.35,37.35,0,0,1-25.19,57.05q-.14,1-.28,2.13l-.24,0c-.16,1.5-.29,3.08-.39,4.73a31.84,31.84,0,0,0,4.9,3.94,40.46,40.46,0,0,0,16.34,5.41,48.63,48.63,0,0,1,19.65,5.84c7.12,4,15,9.79,17.45,16.84,4.12,11.77,26.76,30,42,32.27l5.4-.31.39-.12v.1l1.32-.08.08,0v0l.35,0,0,.08,1.37-.08s.14.63.32,1.75c7.65-2.62,23.88-9.92,45-29.08,23.54-21.35,55.31-17.15,67.56-14.46a2.1,2.1,0,0,1,.56,3.89c-4.94,2.72-12.62,6.67-16.22,7.11,0,0,7.42,7.68-.46,11.78a5.67,5.67,0,0,1-5.93-.57c-3.79-2.77-14.33,3.51-29.59,6.78,0,0-43.08,44.58-64.45,51.48a30.74,30.74,0,0,1-1.63,2.84l-1.32-.11-.07.11h-.18l-.16,1.4s-33.25-1.75-44-13.82a17.32,17.32,0,0,1-2.11-2.25l11.56,145.48h-.11l.11,1.38h-8.5a320.62,320.62,0,0,0,2.28,53.63v94.8s.44,8.35-16.89,20.5a647.93,647.93,0,0,0-52.48,40.67l-2.1,1.82c3.19,29,9.86,83.08,15.42,85.1l-3.43.6c5.91,7.45,22.56,27.89,27.65,28.46,6.23.69,10.38,10.38,0,12.46-9.58,1.92-34.48,4.42-61.65-6.08a9.41,9.41,0,0,1-5.92-10l2-15.28a2.14,2.14,0,0,0-.88.93c-1.38,4.15,0-5.54,0-5.54a433,433,0,0,1-13.38-55.84L438,733s-.42-.51-1.13-1.43c-5,11.44-14,34.81-12,51.95,2.77,23.53-23.53,2.77-20.76-11.07,2.24-11.2-7.75-58.64-11.65-76.34A7.89,7.89,0,0,1,397.65,686.94Z",
  transform: "translate(-134.85 -48.95)",
  fill: "url(#451b59ba-420b-4fc9-a211-ed64f18bebb9)"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M612.52,303s19.6-3.38,48.65-29.73c23-20.85,54-16.74,66-14.12a2,2,0,0,1,.55,3.79c-4.83,2.65-12.33,6.51-15.84,6.95,0,0,7.24,7.5-.45,11.51a5.54,5.54,0,0,1-5.79-.56c-3.7-2.7-14,3.43-28.89,6.62,0,0-58.11,60.14-71.62,50Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fec3be"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M512.51,221.28s-5.41,23,0,39.19l-24.33,3.38L466.57,253V238.85s10.14-21.62,7.43-46.62Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fec3be"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M443.59,719.28S426,753.74,428.73,776.71s-23,2.7-20.27-10.81c2.19-10.93-7.57-57.26-11.37-74.54a7.7,7.7,0,0,1,5.12-9c8.13-2.67,21.72-6,28.56-.94C440.89,688.87,443.59,719.28,443.59,719.28Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#5a5773"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M510.49,757.11s23,29.73,29.06,30.41,10.14,10.14,0,12.16c-9.35,1.87-33.67,4.32-60.2-5.94a9.19,9.19,0,0,1-5.78-9.78l3.81-28.88Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#5a5773"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M548.33,441.56l22,2.94s-5.14,36.92.26,77.47v92.57s.43,8.15-16.49,20a632.65,632.65,0,0,0-51.24,39.71l-61.32,53.12s-24.33-29.73-20.95-47.3c0,0,40.54-12.84,45.95-33.79,3.1-12,18.82-22,31.69-28.35,16.58-8.19,25.62-26.8,21.08-44.72a34.48,34.48,0,0,0-3.45-8.69c-10.81-18.92-26.35-61.49-26.35-61.49l29.73-56.76Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#605d82"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M548.43,441.56l22,2.94s-5.14,36.92.26,77.47v92.57s.43,8.15-16.49,20A632.65,632.65,0,0,0,503,674.27l-61.32,53.12s-24.33-29.73-20.95-47.3c0,0,40.54-12.84,45.95-33.79,3.1-12,18.82-22,31.69-28.35,16.58-8.19,25.62-26.8,21.08-44.72a34.48,34.48,0,0,0-3.45-8.69c-10.81-18.92-26.35-61.49-26.35-61.49l29.73-56.76Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.05
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M515.89,759.14S476,765.9,474.67,770s0-5.41,0-5.41-23-69.6-17.57-131.09-6.76-102-6.76-102-14.19-45.95-6.08-72.3,93.25-14.87,93.25-14.87S507.78,513.86,508.46,547c0,0-3.38,100-9.46,111.49C499,658.46,508.46,756.44,515.89,759.14Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#605d82"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M511.16,238.85s-4.05,25-44.6,14.19l27,205.41s78.38,2.7,77.71-6.76L555.08,327.37Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fff"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M510.15,237.5s7.68,8.24,19.52,9.27a47.49,47.49,0,0,1,19.18,5.71c7,3.89,14.63,9.55,17,16.45,4.73,13.51,34.46,35.81,48,31.08l-4.73,40.54s-38.51-2-45.27-16.89l11.49,144.6H565.22s-5.41-39.19-9.46-47.3-12.16-52.7-12.84-63.52-10.81-73-19.6-83.79l-13.18-32.1Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M510.15,239.53s9,7.57,20.87,8.59a47.49,47.49,0,0,1,19.18,5.71c7,3.89,14.63,9.55,17,16.45,4.73,13.51,34.46,35.81,48,31.08l-4.73,40.54s-38.51-2-45.27-16.89L576.7,469.6H566.57s-5.41-39.19-9.46-47.3-12.16-52.7-12.84-63.52-10.81-73-19.6-83.79l-14.53-31.42Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M510.15,238.18s9,7.57,20.87,8.59a47.49,47.49,0,0,1,19.18,5.71c7,3.89,14.63,9.55,17,16.45,4.73,13.51,34.46,35.81,48,31.08l-4.73,40.54s-38.51-2-45.27-16.89l11.49,144.6H566.57s-5.41-39.19-9.46-47.3-12.16-52.7-12.84-63.52-10.81-73-19.6-83.79l-14.53-31.42Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#67647e"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M475.69,212.16c.88-6.4-.88-10.4-1.69-17.91l38.51,29.06s-.92,3.93-1.62,9.67a36.73,36.73,0,0,1-5.81.47C491.64,233.45,482,223,475.69,212.16Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref59 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 370.23,
  cy: 145.99,
  r: 36.49,
  fill: "#fec3be"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M544.9,159.17a46.19,46.19,0,0,0-3-18.06,4.5,4.5,0,0,1-.77,5.83A28.91,28.91,0,0,0,532,130.7c2.6.42,3.93,3.65,3.3,6.21s-2.61,4.53-4.51,6.35c.22-3.87-2.33-7.47-5.57-9.6s-7.1-3-10.87-3.94a6.3,6.3,0,0,1,4.17,6.46,1.8,1.8,0,0,1-.54,1.25,2.07,2.07,0,0,1-1.23.33,94.57,94.57,0,0,1-11.42-.24,119.71,119.71,0,0,0-14.06-.75c-14.76.62-29.46,10.65-32.75,25a57.43,57.43,0,0,0-1.07,10.54l-.72,18.08c-.21,5.28-.42,10.63.64,15.81A33.49,33.49,0,0,0,474.58,229c5.3-7.68,5.77-17.55,7.61-26.7a13.51,13.51,0,0,1,2.29-5.9c1.33-1.66,3.67-2.71,5.65-1.92s2.84,3.82,1.19,5.17c1.42,1.73,4.22.44,5.85-1.1a31.56,31.56,0,0,0,9.16-16.35c.66-3.15,1.32-7,4.36-8.09a8.2,8.2,0,0,1,3.27-.22c6.43.44,16.49,3.1,22.73,1.06C542.5,173,544.9,164.59,544.9,159.17Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M544.23,158.49a46.19,46.19,0,0,0-3-18.06,4.5,4.5,0,0,1-.77,5.83A28.91,28.91,0,0,0,531.33,130c2.6.42,3.93,3.65,3.3,6.21s-2.61,4.53-4.51,6.35c.22-3.87-2.33-7.47-5.57-9.6s-7.1-3-10.87-3.94a6.3,6.3,0,0,1,4.17,6.46,1.8,1.8,0,0,1-.54,1.25,2.07,2.07,0,0,1-1.23.33,94.57,94.57,0,0,1-11.42-.24,119.71,119.71,0,0,0-14.06-.75c-14.76.62-29.46,10.65-32.75,25a57.43,57.43,0,0,0-1.07,10.54l-.72,18.08c-.21,5.28-.42,10.63.64,15.81a33.49,33.49,0,0,0,17.21,22.74c5.3-7.68,5.77-17.55,7.61-26.7a13.51,13.51,0,0,1,2.29-5.9c1.33-1.66,3.67-2.71,5.65-1.92s2.84,3.82,1.19,5.17c1.42,1.73,4.22.44,5.85-1.1a31.56,31.56,0,0,0,9.16-16.35c.66-3.15,1.32-7,4.36-8.09a8.2,8.2,0,0,1,3.27-.22c6.43.44,16.49,3.1,22.73,1.06C541.82,172.37,544.23,163.92,544.23,158.49Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#916168"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M616.91,300s5.41,25-4.73,40.54l-5.74-.47,3.13-39.65Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M615.56,300s5.41,25-4.73,40.54l-5.74-.47,3.13-39.65Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fd6f8d"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M470.28,231.76l-43.58,37.5S401,295.61,411.83,338.18c0,0,4.73,62.16,10.14,64.87,0,0,18.92,37.84,20.27,73.65,0,0,25.34-51,36.83-19.93s38.18,35.47,38.18,35.47L502.38,308.45S464.88,243.24,470.28,231.76Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M468.93,231.76l-43.58,37.5s-25.68,26.35-14.87,68.92c0,0,4.73,62.16,10.14,64.87,0,0,18.92,37.84,20.27,73.65,0,0,26.69-53.72,38.18-22.64s36.83,38.18,36.83,38.18L501,308.45S463.52,243.24,468.93,231.76Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#67647e"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M449,390.21s-10.81-7.43-28.38,12.84l43.24,78.38,14.53-22S447.65,399,449,390.21Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fec3be"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M459.47,394.6s-23.91,26.86-33.24,22.55L417.59,397,450,383.11Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M459.47,393.25s-23.91,26.86-33.24,22.55l-8.64-20.11L450,381.76Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#fd6f8d"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M476.93,454.38s-11.38,23.33-17.46,24.69l8.78,10.14,12.84-24.33Z",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M477.61,455.05s-11.38,23.33-17.46,24.69l8.78,10.14,12.84-24.33Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#4d4981"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M456.09,310.81s-1.35,48.65,4.05,66.89",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M565.56,320.27s-8.11-2.7-8.11-9.46",
  transform: "translate(-134.85 -48.95)",
  opacity: 0.1
});

var _ref73 =
/*#__PURE__*/
React.createElement("rect", {
  x: 671.58,
  y: 265.76,
  width: 57.41,
  height: 4.1,
  transform: "translate(-83.19 -157.19) rotate(9.18)",
  fill: "#40414d"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M747.51,275.44s-5.87,4-11.51,4.72a11,11,0,0,1-3.11,0c-5.17-.83-7.85-3.36-8.34-6.33a6.84,6.84,0,0,1,.65-4c1.4-2.67,4.74-4.22,9.91-3.38a12.69,12.69,0,0,1,4.44,1.76A32.47,32.47,0,0,1,747.51,275.44Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#40414d"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M747.51,275.44s-5.87,4-11.51,4.72a2.84,2.84,0,0,1,.12-1.88,13.88,13.88,0,0,1,1.9-2.34c.59-.82.75-2.18-.12-2.68a3.43,3.43,0,0,1-.59-.32c-.52-.47,0-1.31.44-1.81.84-.85,1.8-1.86,1.79-3A32.47,32.47,0,0,1,747.51,275.44Z",
  transform: "translate(-134.85 -48.95)",
  fill: "#f8bdc5"
});

var SvgUndrawMakeupArtistRxn8 = function SvgUndrawMakeupArtistRxn8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "18f216cc-8d22-4f63-b3b0-6d2860aae10e",
    "data-name": "Layer 1",
    width: 930.29,
    height: 802.11,
    viewBox: "0 0 930.29 802.11",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawMakeupArtistRxn8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_makeup_artist_rxn8.34fcb15e.svg";
export { ForwardRef as ReactComponent };